import {
  FRAGMENTS_GRID_ITEM_PROPS_BY_VIEW_MODE,
  FRAGMENTS_GRID_SPACING,
} from '@app/modules/fragments/screens/list/fragment-card/constants';

/** Grid breakpoints for the YouTube broadcasts list (fixed normal density). */
export const YOUTUBE_BROADCASTS_GRID_ITEM_SIZE = FRAGMENTS_GRID_ITEM_PROPS_BY_VIEW_MODE.gridWide;

/** Spacing between grid items in the YouTube broadcasts grid. */
export const YOUTUBE_BROADCASTS_GRID_SPACING = FRAGMENTS_GRID_SPACING;

/** Number of skeleton cards shown while the broadcasts grid is loading. */
export const YOUTUBE_BROADCASTS_GRID_SKELETON_COUNT = 12;
